import { fieldCantBeEmptyMsg, t } from '../../common/i18n';
import { addEmptyFieldValidationError } from '../../common/utils/errorUtils';
import type { CommonError } from '../../common/types/errors';
import type { ValidateSubscriptionPairingPayload } from '../../selfservice/actions';

export const OTP_LENGTH = 4;

export function getErrorsFromOneTimePasswordComponent(
  data: ValidateSubscriptionPairingPayload,
  validationErrors?: CommonError[]
): CommonError[] | undefined {
  const errors: CommonError[] = [];
  if (data) {
    if (data.otp.length < OTP_LENGTH) {
      addEmptyFieldValidationError(errors, 'otp', t.VPVR(fieldCantBeEmptyMsg));
    }
  }
  if (errors.length === 0) {
    return validationErrors;
  }
  return errors.concat(validationErrors || []);
}
